export const handleDownloadFile = async (dataurl, filename) => {
  try {
    if (!dataurl) {
      console.error('No data URL provided');
      return;
    }

    let base64Data;
    
    // Check if it's already a data URL or just base64
    if (dataurl.startsWith('data:')) {
      // It's a data URL, extract the base64 part
      const arr = dataurl.split(",");
      if (arr.length < 2) {
        console.error('Invalid data URL format');
        return;
      }
      base64Data = arr[1];
    } else {
      // It's raw base64 data
      base64Data = dataurl;
    }

    // Decode base64 to binary
    const bstr = window.atob(base64Data);
    const n = bstr.length;
    const u8arr = new Uint8Array(n);
    
    for (let i = 0; i < n; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }

    // Create blob and download
    const newBlob = new Blob([u8arr], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const blobUrl = URL.createObjectURL(newBlob);
    
    // Create a link element
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;

    // Append link to the body
    document.body.appendChild(link);
    
    // Dispatch click event on the link
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );

    // Remove link from body and cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};
